module.exports = __webpack_public_path__ + "img/mobile-vi.f66543b4.jpg";